// extracted by mini-css-extract-plugin
module.exports = {"flex":"styles_flex__2QgXB"};